// extracted by mini-css-extract-plugin
export default {"title":"Thankyou_title__UytQW","icons":"Thankyou_icons__vV7HG"};